import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganizersLoginMutation } from '../../../Api/organizers';
import { useGlobalState } from '../../../App/globalState';
import { formatPhoneNumber } from '../../../Helpers/phone-formatter';
import Button from '../../../Style-guide/Button';
import Input from '../../../Style-guide/Input';
import { validate } from '../../SignUp/validator';
import OrganizerLoginWrapper from './style/organizerLoginWrapper';

const OrganizerLogin = () => {
  const { mutate: loginRequest, isSuccess, data } = useOrganizersLoginMutation();
  const navigate = useNavigate();
  const { updateGlobalState } = useGlobalState();

  const [organizerData, setOrganizerData] = useState({
    phone: '',
    password: '',
  });

  const [errors, setErrors] = useState({
    phone: '',
    password: '',
  });

  useEffect(() => {
    if (isSuccess && data && data.organizer) {
      const { hasMultipleCourts, courtId } = data.organizer;

      updateGlobalState({
        organizer: {
          id: data.organizer?.id,
          hasMultipleCourts,
          ses_exp: data.organizer?.ses_exp,
        },
      });

      if (hasMultipleCourts) {
        navigate('/organizers/select-court');
      } else {
        navigate(`/organizers/court/${courtId}`, { replace: true });
      }
    }

    // disabled to prevent infinite update loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = name === 'phone' ? formatPhoneNumber(value) : value;

    setOrganizerData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    let hasError = false;

    Object.entries(organizerData).forEach(([key, value]) => {
      const { isValid, message } = validate(key, value);
      newErrors[key] = isValid ? '' : message;
      if (!isValid) hasError = true;
    });

    setErrors(newErrors);

    if (!hasError) {
      loginRequest({ data: organizerData });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit(event);
    }
  };

  return (
    <OrganizerLoginWrapper>
      <form
        className='organizer-login-container'
        onKeyDown={handleKeyDown}
        onSubmit={handleSubmit}
      >
        <Input
          type='tel'
          name='phone'
          className='organizer-login-input'
          label='Phone number'
          value={organizerData.phone}
          onChange={handleChange}
          autoComplete='off'
          error={errors.phone}
        />
        <Input
          type='password'
          name='password'
          className='organizer-login-input'
          label='Password'
          value={organizerData.password}
          onChange={handleChange}
          autoComplete='off'
          error={errors.password}
        />
        <Button type='submit' className='organizer-login-button'>
          Log In
        </Button>
      </form>
    </OrganizerLoginWrapper>
  );
};

export default OrganizerLogin;
